export default "__VITE_ASSET__DEM5GDxY__"